import React, { Component } from 'react'
import TopNav from '../../components/topnav/topnav';
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Select, Spin } from 'antd';
import Footer from '../../components/footer/footer';

class LearningPaths extends Component {
  render() {
    return (
      <div className="aboutus">
        <TopNav />
        <div className="x-construction">
          <Spin indicator={<Icon type="loading" />} /> <br /><br /> Please check back later
        </div>
        <Footer />
      </div>
    )
  }
}

export default LearningPaths
